import React from "react";
import Header from "../../app/header";
import NavMenu from './components/nav_menu'
import Form from "./components/form";
import Footer from "../../app/footer";
import styles from '../../assets/styles/form.module.scss'

const Register = (props) => {

  return (
    <>
      <div className={styles.container}>
        <Header />
        <NavMenu />
        <Form />
        <Footer />
      </div>
    </>
  );
}

export default Register;